import React, { useEffect, useRef } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import allreportsdata from "../../../json-data/allreports.json";
import allReportsHindidata from "../../../json-data/allReportsHindi.json";
import { fetchArchiveServicesTeacherTrainingData } from "../../../redux/thunks/archiveServicesThunk";
import { useExportToExcel } from "../../../pdfAndExcellUtils/pdfAndExcellUtils";
import { useCallback } from "react";
import {
  initialFilterEnrolmentData,
  state_gov_mgt_code,
  gov_aided_mgt_code,
  pvt_uaided_mgt_code,
  ctrl_gov_mgt_code,
  other_mgt_code,
  pr_sch_code,
  upr_pr_code,
  hr_sec_code,
  sec_sch_code,
  pre_pr_sch_code,
  selectedDYear,
  nationalWiseName,
  stateWiseName,
  district,
  districtWiseName,
  blockWiseName,
  block,
  generateTextContent,
  excelStyles
} from "../../../constants/constants";

import { allFilter } from "../../../redux/slice/schoolFilterSlice";
import { useDispatch, useSelector } from "react-redux";
import { columnsConfigFor2011 } from "../../../constants/constants";

import "../infra.css";
import "../report.scss";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import Highcharts from "highcharts";
import HC_more from "highcharts/highcharts-more";
import { useLocation } from "react-router-dom";
import { GlobalLoading } from "../../GlobalLoading/GlobalLoading";
import { useTranslation } from "react-i18next";
import FilterDropdownCommom358 from "../../Home/filter/FilterDropdownCommon358";
import { removeAllDistrict } from "../../../redux/thunks/districtThunk";
import { removeAllBlock } from "../../../redux/thunks/blockThunk";
import { handleActiveTabs } from "../../../redux/slice/headerSlice";
import { handleMissingData } from "../../../utils/handleMissingData";
import satyamevaimg from "../../../assets/images/satyameva-jayate-img.png";
import udise from "../../../assets/images/udiseplu.jpg";
import nic from "../../../assets/images/nic-sm-logo.png";
import {
  TeacherGraph2008,
  TeacherGraph2009,
  TeacherGraph2010,
  
} from "../TeacherGraph2008";
import { ScrollToTopOnMount } from "../../Scroll/ScrollToTopOnMount";
import { Result } from "antd";

import useReportOverallRegionSum from "../../../CustomHook/useReportOverallRegionSum";
import Footer from "../../Header/Footer";
import { TeacherGraph2005,TeacherGraph2011, TeacherPieGraphManagement2011, TeacherPieGraphManagementBroad2011 } from "./TeacherGraph2005";
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/accessibility")(Highcharts);
require("highcharts/modules/export-data.js")(Highcharts);
require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/treemap")(Highcharts);
require("highcharts/modules/treegraph")(Highcharts);
HC_more(Highcharts);
export default function TeacherReport2011() {
  const dispatch = useDispatch();
  const location = useLocation();
  const schData = useSelector((state) => state.teacherTraining);
  const school_datas = useSelector((state) => state.teacherTraining?.data?.data);
  ////console.log('school_datas', school_datas)
  const [local_state, setLocalStateName] = useState("All India/National");
  const [local_district, setLocalDistrictName] = useState("District");
  const [local_block, setLocalBlockName] = useState("Block");
  const [isScrollComplete, setIsScrollComplete] = useState(false);
    const [isCheckFilter, setIsCheckFilter] = useState(false);
  
  const schoolFilter = useSelector((state) => state.schoolFilter);
  const filterObj = structuredClone(schoolFilter);
  const headerData = useSelector((state) => state.header);
  const local_year = window.localStorage.getItem("year");
  const stateName = localStorage.getItem("state");
  const [customChange, setCustomChange] = useState([]);
  const [groupKeys, setGroupKeys] = useState({
    schManagementBroad: false,
    schManagementDesc: false,
    schLocURDesc: false,
  });

  const [selectedBtn, setSelectedBtn] = useState("Broad");

  const [groupKeysForGraph, setgroupKeysForGraph] = useState({
    schManagementBroad: false,
    schManagementDesc: false,
    schLocURDesc: false,
  });

  useEffect(() => {
    dispatch(removeAllDistrict());
    dispatch(removeAllBlock());
  }, []);
  useEffect(() => {
    window.localStorage.setItem("state", "All India/National");
    window.localStorage.setItem("map_state_name", "All India/National");
    window.localStorage.setItem("map_district_name", "District");
    window.localStorage.setItem("district", "District");
    window.localStorage.setItem("block", "Block");
  }, []);

  useEffect(() => {
    setLocalStateName(localStorage.getItem("state"));
    setLocalStateName(localStorage.getItem("map_state_name"));
    setLocalDistrictName(localStorage.getItem("map_district_name"));
    setLocalBlockName(localStorage.getItem("block"));
  }, [filterObj, headerData.activeTab]);

  const [mgt, setMgt] = useState("");
  const [mgt_Details, setMgtDetail] = useState("");
  const [cat, setCat] = useState("");
  const [cat_Details, setCatDetail] = useState("");
  const [ur, setUR] = useState("");
  const [multiMgt, setMultiMgts] = useState("");
  const [multiCat, setMultiCats] = useState("");
  const [queryParameters] = useSearchParams();
  const id = queryParameters.get("id");
  const type = queryParameters.get("type");
  const [intialStudentData, setIntialStudentData] = useState(school_datas);
  const gridApiRef = useRef(null);
  const [activeTab, setActiveTab] = useState(type);
  const { t, i18n } = useTranslation();
  dispatch(handleActiveTabs(activeTab));
  useEffect(() => {
    setIntialStudentData(school_datas);
  }, [school_datas]);

  // Taking the both reports data condition wise for language change
  useEffect(() => {
    const reportsData =
      i18n.language === "hi" ? allReportsHindidata : allreportsdata;

    for (const category in reportsData) {
      const foundReport = reportsData[category].find(
        (report) => report.id === parseInt(id)
      );
      if (foundReport) {
        setReport(foundReport);
        break;
      }
    }
  }, [id, i18n.language]);

  useEffect(() => {
    dispatch(allFilter(initialFilterEnrolmentData));
    dispatch(
      fetchArchiveServicesTeacherTrainingData(initialFilterEnrolmentData)
    );
  }, [dispatch]);
  const [report, setReport] = useState(null);
  const [gridApi, setGridApi] = useState();
  const [arrGroupedData, setArrGroupedData] = useState([]);
  const [arrGroupedGraphData, setArrGroupedGraphData] = useState([]);
  const [gridRefreshKey, setGridRefreshKey] = useState(0);
  const [data, setData] = useState([]);
  const [graphData, setGraphData] = useState({
    categories: [],
    series: [],
  });

  const [graphDataCategories, setGraphDataCategories] = useState({
    categories: [],
    series: [],
  });

  const filter_query_by_location =
    // local_state === "All India/National" ||
    local_state === "State Wise" ||
    local_district === "District Wise" ||
    local_block === "Block Wise";

  const [columns, setColumn] = useState([
    {
      headerName: "Serial Number",
      field: "Serial Number",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
    },

    {
      headerName: "",
      headerClass: "headerStyle",
      children: [
        {
          headerName: "",
          headerClass: "headerStyle",
          children: [
            {
              headerName: "Location",
              field: "regionName",
              hide: !filter_query_by_location,
            },
            {
              headerName: "School Management(Broad)",
              field: "schManagementBroad",
              suppressColumnsToolPanel: true,
              hide: true,
            },
            {
              headerName: "School Management(Detailed)",
              field: "schManagementDesc",
              suppressColumnsToolPanel: true,
              hide: true,
            },

            {
                headerName: "School Category(Detailed)",
                field: "schCatDesc",
                suppressColumnsToolPanel: true,
                hide: true,
              },
           
          ],
        },
      ],
    },
    {
        headerNameKey: "",
        headerClass: "headerStyle",
        children: [
            {
              headerNameKey: "Teacher Trained for CWSN",
              headerClass: "headerStyle",
              children: [
                { headerNameKey: "Male", field: "totTchCWSNTrainedM", hide: false },
                { headerNameKey: "Female", field: "totTchCWSNTrainedF", hide: false },
                { headerNameKey: "Total", field: "totTchCWSNTrained" },
  
              ],
            }
         
        //   {
        //     headerNameKey: "",
        //     hide: false,
        //     children: [
        //       {
        //         headerNameKey: "Overall",
        //         field: "total",
        //         valueGetter: (params) => params.data ? params.data.total : null,
        //         aggFunc: 'sum', 
        //       },
        //     ],
        //   },
        ],
      },
  ]);

  const [defColumnDefs] = useState({
    flex: 1,
    minWidth: 150,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    // filter: true,
    autoHeaderHeight: true,
    headerClass: "headerStyle"
  });
  function onColumnVisible(event) {
    const columnId = event?.column?.colId;
    const visible = event.visible;
    if (columnId === "schManagementBroad") {
      setGroupKeys((prev) => ({
        ...prev,
        schManagementBroad: visible,
      }));
      setMgt(() => (visible ? "active" : ""));
      setMultiMgts(() => (visible ? "multibtn" : ""));
    }
    if (columnId === "schManagementDesc") {
      setGroupKeys((prev) => ({
        ...prev,
        schManagementDesc: visible,
      }));
      setMgtDetail(() => (visible ? "active" : ""));
      setMultiMgts(() => (visible ? "multibtn" : ""));
    }

    if (columnId === "schLocURDesc") {
      setGroupKeys((prev) => ({
        ...prev,
        schLocURDesc: visible,
      }));
      setUR(() => (visible ? "active" : ""));
    }

    
    const pinnedBottomRowData = ((anyGroupKeyTrue || (local_state !== "All India/National")) && ((anyGroupKeyTrue || (local_state === "State Wise")) || (anyGroupKeyTrue || (local_district === "District Wise")) || (anyGroupKeyTrue || (local_block === "Block Wise"))))
    ? (  pinedBottomRowDatas)
    : [];
  
    setCustomChange(pinnedBottomRowData);
    if(groupKeys.schManagementBroad){
      // alert("in broad")
      graphDataPrepare("broad")
    }else if(groupKeys.schManagementDesc){
      // alert("in detailded")
      // graphDataPrepare("desc") //need to fix and uncomment when chart will enabled
    }
    
  }

  const onGridReady = (params) => {
    if (!params) {
      return;
    }
    gridApiRef.current = params?.api;
    setColumnVisibility(groupKeys);
    setGridApi(params);
  };

  const setColumnVisibility = (keys) => {
    if (gridApiRef.current) {
      const gridApi = gridApiRef.current;
      Object.keys(keys)?.forEach((key) => {
        gridApi?.columnApi?.setColumnVisible(key, keys[key]);
      });
    }
  };
  const handleCustomKeyInAPIResponse = () => {
    const arr = [];
    school_datas?.forEach((item, idx) => {
      let appendedObj = { ...item };
      /* broad management key added*/
      if (state_gov_mgt_code.includes(item.schManagementCode)) {
        appendedObj.schManagementBroad = "State Government";
      } else if (gov_aided_mgt_code.includes(item.schManagementCode)) {
        appendedObj.schManagementBroad = "Govt. Aided";
      } else if (pvt_uaided_mgt_code.includes(item.schManagementCode)) {
        appendedObj.schManagementBroad = "Private Unaided";
      } else if (ctrl_gov_mgt_code.includes(item.schManagementCode)) {
        appendedObj.schManagementBroad = "Central Government";
      } else if (other_mgt_code.includes(item.schManagementCode)) {
        appendedObj.schManagementBroad = "Others";
      }
      arr.push(appendedObj);
    });
    ////console.log('array-original',arr)
    setData(arr);
    graphDataPrepare();
    ////console.log('dataa',data)
    // setGraphData(arr);
  };

  const generateKey = (item, filters) => {
    ////console.log('filters', filters)
    ////console.log('item-key', item)
    const {
      regionName,
      schManagementBroad,
      schManagementDesc,
      schLocURDesc,
    } = item;
    let keyParts = [regionName];

    if (filters.schManagementBroad) keyParts.push(schManagementBroad);
    if (filters.schManagementDesc) keyParts.push(schManagementDesc);
    if (filters.schLocURDesc) keyParts.push(schLocURDesc);
    return keyParts.join("-");
  };

  const groupData = (data, filters) => {
    const groupedData = {};

    data.forEach((item) => {
      const key = generateKey(item, filters); 
      ////console.log(key,'generateKey');

        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            totTchCWSNTrainedF: 0,
            totTchCWSNTrainedM: 0,
            totTchCWSNTrained: 0
            
          };
        }
        groupedData[key].totTchCWSNTrainedF += parseInt(item.totTchCWSNTrainedF, 10);
        groupedData[key].totTchCWSNTrainedM += parseInt(item.totTchCWSNTrainedM, 10);
        groupedData[key].totTchCWSNTrained += parseInt(item.totTchCWSNTrained, 10);
    });
     ////console.log(groupedData,'there');
     
    return Object.values(groupedData);
  };

  const handleButtonClick = (type, detailType) => {
    handleFilterClick(type, detailType);

    detailType === "broad" ? setSelectedBtn("Broad") : setSelectedBtn("Detailed");

    if (type === "School Management") {
      setMgt((prevMgt) =>
        detailType === "broad" ? (prevMgt === "active" ? "" : "active") : ""
      );
      setMgtDetail((prevMgtDetail) =>
        detailType === "desc"
          ? prevMgtDetail === "active"
            ? ""
            : "active"
          : ""
      );
    }

    if (type === "School Category") {
      setCat((prevCat) =>
        detailType === "broad" ? (prevCat === "active" ? "" : "active") : ""
      );
      setCatDetail((prevCatDetail) =>
        detailType === "desc"
          ? prevCatDetail === "active"
            ? ""
            : "active"
          : ""
      );
    }

    gridApiRef.current.setFilterModel(null);
    gridApiRef.current.onFilterChanged();

  };

  useEffect(() => {
    setColumn((prevColumns) => {
      const updatedColumns = [...prevColumns];
      const firstChild = updatedColumns[1].children[0].children;

      const updateColumnVisibility = (field, isVisible) => {
        const index = firstChild.findIndex((col) => col.field === field);
        if (index !== -1) {
          firstChild[index].hide = !isVisible;
        }
      };

      if (groupKeys.schManagementBroad !== undefined) {
        updateColumnVisibility(
          "schManagementBroad",
          groupKeys.schManagementBroad
        );
      }
      if (groupKeys.schManagementDesc !== undefined) {
        updateColumnVisibility(
          "schManagementDesc",
          groupKeys.schManagementDesc
        );
      }
      if (groupKeys.schLocURDesc !== undefined) {
        updateColumnVisibility("schLocURDesc", groupKeys.schLocURDesc);
      }
      updateColumnVisibility("regionName", filter_query_by_location);
      const updatedDefs = updatedColumns.map((colGroup) => ({
        ...colGroup,
        children: colGroup.children?.map((col) => ({
          ...col,
          hide: firstChild.find((c) => c.field === col.field)?.hide || col.hide,
          headerClass: "headerStyle",
        })),
      }));

      return updatedDefs;
    });

    ////console.log('columns ',columns)

//   ////console.log("total "+sum)
    const grouped = groupData(data, groupKeys);
    setArrGroupedData(grouped);
    setColumnVisibility(groupKeys);
  }, [groupKeys, data, filter_query_by_location, school_datas]);

  // using use effect to translate the data
  useEffect(() => {
    const translateColumns = (columnsArray) => {
      return columnsArray?.map((col) => {
        // Add your condition here
        if (col.headerNameKey === 'School Management(Broad)' || col.headerNameKey === 'School Management(Detailed)' || col.headerNameKey === 'School Category(Broad)'
          || col.headerNameKey === 'School Category(Detailed)' || col.headerNameKey === 'Urban/Rural'
        ) {
          // For example, if the column field is 'price', apply a different translation or logic
          return {
            ...col,
            filter: true,
            headerClass: "headerStyle",
            headerName: t(col.headerNameKey),
            children: col.children ? translateColumns(col.children) : col.children,
            // Any additional modifications specific to 'price' field
            width: 150, // Example: Set width specifically for price column
          };
        }
    else{
      return {
        ...col,
        filter: false,
        headerClass: "headerStyle",
        headerName: t(col.headerNameKey),
        children: col.children ? translateColumns(col.children) : col.children,
      };
    }
        // Default behavior if the condition is not met
   
      });
    };

    const translatedColumns = translateColumns(columnsConfigFor2011);

    setColumn(translatedColumns);
    ////console.log('columns ',columns)
  }, [t]);

  // const handleFilterClick =  (type, detailType) => {
  //   alert("called in filter");
  //   setGroupKeys((prevFilters) => {
  //     const newFilters = { ...prevFilters };
  //     if (type === "School Management") {
  //       if (detailType === "broad") {
  //         newFilters.schManagementBroad = !prevFilters.schManagementBroad;
  //         newFilters.schManagementDesc = false;
  //       } else if (detailType === "desc") {
  //         newFilters.schManagementDesc = !prevFilters.schManagementDesc;
  //         newFilters.schManagementBroad = false;
  //       }
  //     } 

  //     return newFilters;
  //   });
  // };


  const handleFilterClick = (type, detailType) => {
    setGroupKeys((prevFilters) => {
      const newFilters = { ...prevFilters };
      if (type === "School Management") {
        if (detailType === "broad") {
          newFilters.schManagementBroad = !prevFilters.schManagementBroad;
          newFilters.schManagementDesc = false;
          // newFilters.schCategoryDesc = false;
        } else if (detailType === "desc") {
          newFilters.schManagementDesc = !prevFilters.schManagementDesc;
          // newFilters.schCategoryDesc = !prevFilters.schCategoryDesc;
          newFilters.schManagementBroad = false;
        }
      } 

      return newFilters;
    });
  };

  const getLastTrueToShowTotal = () => {
    const lastTrueKey = Object.keys(groupKeys).reduce((lastKey, key) => {
      if (groupKeys[key]) {
        return key;
      }
      return lastKey;
    }, null);
    return lastTrueKey;
  };
  function calculateTotal(fieldName) {
    if (!arrGroupedData) return 0;
    return arrGroupedData.reduce(
      (total, row) => total + parseFloat(row[fieldName] || 0),
      0
    );
  }

  const pinedBottomRowDatas = [
    {
      ...(getLastTrueToShowTotal()
        ? { [getLastTrueToShowTotal()]: "Total" }
        : { regionName: "Total" }),
        totTchCWSNTrainedF: calculateTotal("totTchCWSNTrainedF"),
        totTchCWSNTrainedM: calculateTotal("totTchCWSNTrainedM"),
        totTchCWSNTrained: calculateTotal("totTchCWSNTrained"),
        
      // Correct total calculation
      total:
        calculateTotal("totTchCWSNTrainedF") +
        calculateTotal("totTchCWSNTrainedM") +
        calculateTotal("totTchCWSNTrained")  ,
        
    },
  ];

  /*------------Export data to Excel and PDF-------------*/
  const getHeaderToExport = (gridApi) => {
    if (!gridApi) {
      return;
    }
    const columns = gridApi?.api?.getAllDisplayedColumns();
    ////console.log('columns', columns)
    const headerCellSerialNumber = {
      text: "Serial Number",
      headerName: "S.NO.",
      bold: true,
      margin: [0, 12, 0, 0],
    };
    const headerRow = columns?.map((column) => {
      const { field, headerName } = column?.getColDef();
      const sort = column?.getSort();
      const headerNameUppercase = field[0]?.toUpperCase() + field?.slice(1);
      const headerCell = {
        text: headerNameUppercase + (sort ? ` (${sort})` : ""),
        headerName: headerName,
        bold: true,
        margin: [0, 12, 0, 0],
      };
      return headerCell;
    });
    headerRow.unshift(headerCellSerialNumber);
    return headerRow;
  };
  const getRowsToExport = (gridApi) => {
    if (!gridApi) {
      return;
    }
    const columns = gridApi?.api?.getAllDisplayedColumns();
    const getCellToExport = (column, node) => ({
      text: gridApi.api.getValue(column, node) ?? "",
    });
    const rowsToExport = [];
    gridApi?.api?.forEachNodeAfterFilterAndSort((node) => {
      const rowToExport = [];
      rowToExport.push({ text: rowsToExport.length + 1 });
      if (!columns) {
        return;
      }
      columns?.forEach((column) => {
        rowToExport?.push(getCellToExport(column, node));
      });
      rowsToExport.push(rowToExport);
    });
    return rowsToExport;
  };
  const getDocument = (gridApi) => {
    if (!gridApi) {
      return;
    }
    const headerRow = getHeaderToExport(gridApi);
    ////console.log('headerRow', headerRow)
    const rows = getRowsToExport(gridApi);
    const anyGroupKeyTrue = Object.values(groupKeys).some((value) => value === true);
    const pinnedBottomRowData = ((anyGroupKeyTrue || (local_state !== "All India/National")) && ((anyGroupKeyTrue || (local_state === "State Wise")) || (anyGroupKeyTrue || (local_district === "District Wise")) || (anyGroupKeyTrue || (local_block === "Block Wise"))))
    ? (pinedBottomRowDatas)
    : [];
    const pinnedBottomRow = pinnedBottomRowData
    const date = new Date();
    const formattedDate = `${date.toLocaleDateString("en-GB", {
      weekday: "long", // Full day name (e.g., Friday)
    })}, ${date.toLocaleDateString("en-GB", {
      day: "2-digit", // Day of the month (e.g., 13)
      month: "long", // Full month name (e.g., September)
      year: "numeric", // Full year (e.g., 2024)
    })}, ${date.toLocaleTimeString("en-US", {
      hour: "2-digit", // Hour (e.g., 10)
      minute: "2-digit", // Minutes (e.g., 25)
      hour12: true, // 12-hour format with AM/PM
    })}`;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "in",
      format: [12, 20],
    });
    // Function to add header
    const addHeader = () => {
      doc.setFontSize(22);
      doc.setTextColor("black");
      doc.setFont("Helvetica", "bold");
      // doc.text("UDISE+", 0.6, 1);

      // Add the header text
      doc.text(
        "Unified District Information System for Education",
        doc.internal.pageSize.width / 2,
        0.7,
        {
          fontStyle: "bold",

          color: "black",
          align: "center",
        }
      );
      doc.setFont("Helvetica", "normal");

      doc.setFontSize(18);

      doc.text(
        "Department of School Education & Literacy, Ministry of Education, Government of India",
        doc.internal.pageSize.width / 2,
        1.1,
        {
          // fontStyle: '',
          color: "black",
          align: "center",
        }
      );

      doc.setFont("Helvetica", "bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      doc.text(`${report.report_name}`, doc.internal.pageSize.width / 2, 1.5, {
        fontSize: 12,
        fontStyle: "bold",

        color: "black",
        align: "center",
      });

      doc.setFont("Helvetica", "bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      // doc.text(`${stateName}`, doc.internal.pageSize.width / 2, 1.7, {
      //   fontSize: 12,
      //   color: "black",
      //   align: "center",
      // });

      doc.setFont("bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      doc.text(
        `Academic Year : ${local_year}`,
        doc.internal.pageSize.width / 2,
        1.9,
        {
          fontSize: 12,
          color: "black",
          align: "center",
        }
      );

      const textContent = generateTextContent(
        stateName,
        nationalWiseName,
        stateWiseName,
        local_district,
        district,
        districtWiseName,
        local_block,
        block,
        blockWiseName
      );
      if (textContent) {
        doc.text(textContent, doc.internal.pageSize.width / 2, 2.3, {
          fontSize: 12,
          color: "black",
          align: "center",
        });
      }

      // Set the margin for the image from the left
      const leftMargin = 0.1; // Margin from the left (in inches)
      const topLeftX = leftMargin; // X position from the left including margin
      const topLeftY = 0; // Y position from the top (in inches)
      const imgWidth = 2; // Image width (in inches)
      const imgHeight = 2; // Image height (in inches)

      doc.setFontSize(20);
      doc.setTextColor("blue");

      // Add the satyameva image with the specified left margin
      doc.addImage(
        satyamevaimg,
        "PNG",
        topLeftX,
        topLeftY,
        imgWidth,
        imgHeight
      );

      doc.setTextColor("blue");
      doc.setFont("bold");

      // Get page dimensions
      const pageWidthE = doc.internal.pageSize.getWidth();
      const pageHeightE = doc.internal.pageSize.getHeight();

      const imgWidthE = 2.8; // Image width (in inches)
      const imgHeightE = 1.4; // Image height (in inches)
      const marginRight = 0.7; // Right margin (in inches)

      // Calculate x position for top-right corner
      const topRightX = pageWidthE - imgWidthE - marginRight;
      const topRightY = 0.3; // Y position from the top (in inches)

      // Add the education image at the top-right corner
      doc.addImage(
        udise,
        "JPG",
        topRightX, // X position for top-right
        topRightY, // Y position for top-right
        imgWidthE,
        imgHeightE
      );

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Example: Draw a rectangle around the whole page
      // doc.setLineWidth(0.02); // Thicker border for the page
      // doc.rect(0.1, 0.1, pageWidth - 0.2, pageHeight - 0.2); // x, y, width, height
    };
    // Function to add footer
    const addFooter = () => {};
    const table = [];
    table.push(headerRow.map((cell) => cell.headerName));
    rows.forEach((row) => {
      table.push(row.map((cell) => cell.text));
    });
    if (pinnedBottomRow && pinnedBottomRow.length > 0) {
      pinnedBottomRow.forEach((row) => {
        const totalRow = headerRow.map((header) => {
          let field = header.text;
          if (row.hasOwnProperty(field.charAt(0).toLowerCase() + field.slice(1))) {
            field = field.charAt(0).toLowerCase() + field.slice(1);
          } else if (row.hasOwnProperty(field.charAt(0).toUpperCase() + field.slice(1))) {
            field = field.charAt(0).toUpperCase() + field.slice(1);
          }
          return row[field] !== undefined ? row[field].toString() : "";
        });
    
        table.push(totalRow);
      });
    }
    const headers = [];
    // First row: Social Category spanning all columns
    headers.push([
      {
        content: "Social Category",
        colSpan: table[0].length,
        styles: { halign: "center" },
      },
    ]);

    // Second row: Category headers
    const secondRow = [
      { content: "", colSpan: 1, styles: { halign: "center" } },
    ];
    columns[2].children.forEach((category) => {
      secondRow.push({
        content: category.headerName,
        colSpan: category.children.length,
        styles: { halign: "center" },
      });
    });

    const numberOfColumns = table[0].length;
    const baseValue = 10;
    const extraCells = numberOfColumns - baseValue;
    // Add empty cells to the start of secondRow
    if (extraCells > 0) {
      for (let i = 0; i < extraCells; i++) {
        secondRow.unshift({ content: "", colSpan: 1 });
      }
    }

    const thirdRow = [{ content: "", styles: { halign: "center" } }];
    table[0].forEach((header) => {
      thirdRow.push({ content: header, styles: { halign: "center" } });
    });
    thirdRow.shift();
    headers.push(secondRow);
    headers.push(thirdRow);

    addHeader();
    doc.autoTable({
      head: headers,
      body: table.slice(1),
      theme: "grid",
      startY: 2.7,
      styles: {
        cellPadding: 0.15, // Adjust cell padding if needed
        lineColor: [0, 0, 0], // Set border color (black in this case)
        lineWidth: 0.001, // Set border width
        fillColor: [255, 255, 255], // Default background color (white)
        textColor: [0, 0, 0],
      },
      headStyles: {
        fontSize: 14, // Set the font size for the header row
        fontStyle: "bold", // Make the header text bold (optional)
        textColor: [0, 0, 0],
        cellPadding: 0.2, // Set text color for the header row
        halign: "center",
      },

      didParseCell: function (data) {
        const headerRow = getHeaderToExport(gridApi); // Get the header row

        // Get the header text for this column
        const columnHeaderText = headerRow[data.column.index]?.text;
        const columnHeaderHeaderName = headerRow[data.column.index]?.headerName;
        // Check if the current column header is "Serial Number"
        if (columnHeaderText === "Serial Number") {
          data.cell.styles.halign = "center";
        } else if (
          columnHeaderText === "RegionName" ||
          columnHeaderText === "Location"
        ) {
          data.cell.styles.halign = "left";
        } else if (
          columnHeaderText === "SchManagementBroad" ||
          columnHeaderText === "SchCategoryBroad" ||
          columnHeaderText === "SchTypeDesc" ||
          columnHeaderText === "schLocURDesc" ||
          columnHeaderText === "schManagementDesc" ||
          columnHeaderText === "schManagementDesc" ||
          columnHeaderText === "schCategoryIdDesc"
        ) {
          data.cell.styles.halign = "left";
        } else {
          data.cell.styles.halign = "right";
        }
      },

      afterPageContent: addFooter,
    });

    const totalPages = doc.internal.getNumberOfPages();
    doc.page = 1;
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(14);
      doc.setFont("helvetica", "normal");
      doc.addImage(
        nic,
        "JPG",
        0.6, // X position for top-right
        11.5, // Y position for top-right
        1,
        0.3
      );
      doc.setTextColor("black");
      doc.text(
        `Page ${i} of ${totalPages}`,
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 0.2,
        { align: "center", color: "black" }
      );

      doc.text(
        `Report generated on : ${formattedDate}`,
        doc.internal.pageSize.width - 1,
        doc.internal.pageSize.height - 0.2,
        { fontSize: 12, align: "right", color: "black" }
      );
    }
    for (let i = 0; i < totalPages; i++) {
      doc.setPage(i + 1);
      doc.autoTable({
        startY: 3.5,
      });
    }
    return doc;
  };
  const exportToPDF = () => {
    if (!gridApi) {
      return;
    }
    const doc = getDocument(gridApi);
    doc.save(`${report.report_name}.pdf`);
  };
  
      const { exportToExcel } = useExportToExcel(gridApi, report, local_year, stateName, nationalWiseName, stateWiseName, local_district, district, districtWiseName, local_block, block, blockWiseName, generateTextContent);
  

  const handleExportData = (e) => {
    const { value } = e.target;
    if (value === "export_pdf") {
      if (!gridApi) {
        return;
      }
      exportToPDF();
    }
    if (value === "export_excel") {
      exportToExcel();
    }
    document.getElementById("export_data").selectedIndex = 0;
  };
  useEffect(() => {
    if (intialStudentData && intialStudentData.length > 0) {
      handleCustomKeyInAPIResponse();
    }
  }, [intialStudentData, school_datas, location.pathname]);
  //  ........................Graph code statr here.....................
  // ...Start Total No. of Teacher by School Management & School Category.....
  const generateKeyGraph = (item, filters) => {
    const { schManagementBroad } = item;
    let keyParts = [schManagementBroad];
    return keyParts.join("-");
  };

  const groupGraphData = (data, filters) => {
    const groupedData = {};

    data.forEach((item) => {
        const key = generateKey(item, filters); 
          if (!groupedData[key]) {
            groupedData[key] = {
              ...item,
              totTchCWSNTrainedF: 0,
              totTchCWSNTrainedM: 0,
              totTchCWSNTrained: 0,
            };
          }
    
        groupedData[key].totTchCWSNTrainedF += parseInt(item.totTchCWSNTrainedF, 10);
        groupedData[key].totTchCWSNTrainedM += parseInt(item.totTchCWSNTrainedM, 10);
        groupedData[key].totTchCWSNTrained += parseInt(item.totTchCWSNTrained, 10);

      });

    return Object.values(groupedData);
  };

  useEffect(() => {
    const grouped = groupGraphData(data, groupKeys);
    setArrGroupedGraphData(grouped);
  }, [groupKeys, graphData, filter_query_by_location, school_datas]);

  //Code For Graph 1

  // Taking Objects for category and management
  const categoryTranslations = {
    "Primary (PRY)": t("categories_school.Primary (PRY)"),
    "Upper Primary (UPR)": t("categories_school.Upper Primary (UPR)"),
    "Higher Secondary (HSEC)": t("categories_school.Higher Secondary (HSEC)"),
    "Secondary (SEC)": t("categories_school.Secondary (SEC)"),
  };

  const managementTranslations = {
    "State Government": t("managements.State Government"),
    "Govt. Aided": t("managements.Govt. Aided"),
    "Private Unaided": t("managements.Private Unaided"),
    "Central Government": t("managements.Central Government"),
    Others: t("managements.Others"),
  };

  // function to translate the data dynamically
  const translateDataKeys = (
    data,
    categoryTranslations,
    managementTranslations
  ) => {
    return data.map((item) => ({
      ...item,
      schManagementBroad:
        managementTranslations[item.schManagementBroad] ||
        item.schManagementBroad,
    }));
  };

  const processGraphData = (data) => {
    const translatedData = translateDataKeys(
      data,
      categoryTranslations,
      managementTranslations
    );

    // Define categories and managements in Hindi
    const categories = Object.values(categoryTranslations);
    const managements = [
      { name: managementTranslations["State Government"], color: "#751539" },
      { name: managementTranslations["Govt. Aided"], color: "#E6694A" },
      { name: managementTranslations["Private Unaided"], color: "#F5BF55" },
      { name: managementTranslations["Central Government"], color: "#BCE263" },
      { name: managementTranslations["Others"], color: "#57C1BB" },
    ];
    const abbreviateCategory = (category) => {
      return category.replace(/\s*\([^)]*\)/, "");
    };

    const seriesData = managements.map((management) => ({
      name: management.name,
      data: categories.map((category) => {
        const total = translatedData
          .filter(
            (item) =>
              item.schManagementBroad === management.name
          )
          .reduce((acc, curr) => acc + curr.totalSchCatWise, 0);
        return total;
      }),
      color: management.color,
    }));

    const abbreviatedCategories = categories.map(abbreviateCategory);

    const abbreviatedSeriesData = seriesData.map((series) => ({
      ...series,
      name: series.name.replace("Government", "Govt."),
    }));

    return {
      categories: abbreviatedCategories,
      series: abbreviatedSeriesData,
    };
  };

  const graphScmSchData = processGraphData(arrGroupedGraphData);

  useEffect(() => {
    if (headerData.activeTab === "table") {
      window.localStorage.setItem("state", "All India/National");
      window.localStorage.setItem("map_state_name", "All India/National");
      window.localStorage.setItem("map_district_name", "District");
      window.localStorage.setItem("district", "District");
      window.localStorage.setItem("block", "Block");
      window.localStorage.setItem("year", selectedDYear);
      dispatch(
        fetchArchiveServicesTeacherTrainingData(initialFilterEnrolmentData)
      );
    }
    if (headerData.activeTab === "graph") {
      handleButtonClick(
        "School Management",
        "broad"
      )
      window.localStorage.setItem("state", "All India/National");
      window.localStorage.setItem("map_state_name", "All India/National");
      window.localStorage.setItem("map_district_name", "District");
      window.localStorage.setItem("district", "District");
      window.localStorage.setItem("block", "Block");
      window.localStorage.setItem("year", selectedDYear);
      dispatch(
        fetchArchiveServicesTeacherTrainingData(initialFilterEnrolmentData)
      );

    
    }
  }, [headerData.activeTab, dispatch]);

  const handleScrollComplete = () => {
    setIsScrollComplete(true);
  };
  // Use `arrGroupedData` as the source data and apply the `handleMissingData` function to replace null values with "0".
  // The `handleMissingData` function is used to process data and ensure missing values are replaced,
  // which is then displayed in AG Grid using the processed data.

  ////console.log('columns', columns)
  const arrGroupedDataTable = handleMissingData(arrGroupedData, columns).map(
    (item) => ({
      ...item,
      total:
        item.totTchCWSNTrainedF +
        item.totTchCWSNTrainedM +
        item.totTchCWSNTrained ,
    })
  );


  const result = useReportOverallRegionSum(arrGroupedDataTable);

  ////console.log('arrGroupedDataTable', arrGroupedDataTable)

  const anyGroupKeyTrue = Object.values(groupKeys).some((value) => value === true);
  const pinnedBottomRowData = ((anyGroupKeyTrue || (local_state !== "All India/National")) && ((anyGroupKeyTrue || (local_state === "State Wise")) || (anyGroupKeyTrue || (local_district === "District Wise")) || (anyGroupKeyTrue || (local_block === "Block Wise"))))
  ? (  pinedBottomRowDatas)
  : [];

  const onFilterChanged = () => {
    const gridApi = gridApiRef.current;
        const appendedObj = {};
        const finalAppendedObj = [];
        const removefirstTwoColumns = columns.slice(2);
        const visibleColumnsName = columns[1];
        const allData = [];
        gridApi.forEachNodeAfterFilter((node) => {
          if(node.data['School Management(Broad)'] !='Overall'){
            allData.push(node.data);
        }
      });
      visibleColumnsName?.children[0]?.children.forEach((item) => {
        if(!item.hide) appendedObj[item.field]="";
      });
      removefirstTwoColumns[0]?.children.forEach((items)=>{

     
        items.children.forEach((item) => {
            appendedObj[item.field] = filterCalculateTotal(allData,item.field);
        });
      })
        



        appendedObj['schCategoryBroad']="";
        appendedObj['schCategoryDesc']="";
        appendedObj['Location']="";
        appendedObj['schManagementBroad']="";
        appendedObj['schManagementDesc']="";
        appendedObj['schTypeDesc']="";
      if(groupKeys.schManagementBroad){
        appendedObj['schManagementBroad']="Total";
      }else if(groupKeys.schManagementDesc){
        appendedObj['schManagementDesc']="Total";
      }else if(groupKeys.schCategoryBroad){
        appendedObj['schCategoryBroad']="Total";
      }else if(groupKeys.schCategoryDesc){
        appendedObj['schCategoryDesc']="Total";
      }else if(groupKeys.schTypeDesc){
        appendedObj['schTypeDesc']="Total";
      }else if(groupKeys.schLocationDesc){
        appendedObj['Location']="Total";
      }

      if(filter_query_by_location){
        const columnDefs = gridApi.getColumnDefs();
        const childrenData = columnDefs[1].children;

        const fieldValue = childrenData.map((item) => item.children);
        let childrenData1 = fieldValue.flat();
        console.log(data)
        

        setIsCheckFilter(false);
        for (let i = 0; i < childrenData1.length; i++) {
          const columnId = childrenData1[i].field;
          const filterInstancePro = gridApi.getColumnFilterInstance(columnId);
          const getValueFromFilterInstance = async () => {
            try {
              const filterInstance = await filterInstancePro;
            if(filterInstance && filterInstance?.appliedModel !=null){
              if(filterInstance?.appliedModel?.values?.length != filterInstance?.valueModel?.allValues?.size){
                setIsCheckFilter(true);
              }
            }
            } catch (error) {
              console.error("Error fetching filter model:", error);
            }
          };
          getValueFromFilterInstance();
        }
      }

        setCustomChange([appendedObj]);
      };
    
    
      function filterCalculateTotal(data,fieldName) {
        
        if (!data) return 0;
        return data.reduce(
          (total, row) => total + parseFloat(row[fieldName] || 0),
          0
        );
      }


      const graphManagement = [
        { name: "Male", data: [] },
        { name: "Female", data: [] },
        { name: "Total", data: [] },
      ];
    
      

      const graphDataPrepare = (type) => {
        //// Broad management ////
        const broadManagement = [
          "State Government",
          "Govt. Aided",
          "Private Unaided",
          "Central Government",
          "Others",
        ];
    
        const managementDetailed = [
          "Department of Education",
          "Tribal Welfare Department",
          "Local Body",
          "Other State Govt. Managed",
          "Private Unaided (Recognized) ",
          "Partially Govt. Aided",
          "Unrecognized",
           "Social Welfare Department",
          "Kendriya Vidyalaya",
          "Railway School",
          "Central Tibetan School",
          "Madrasa Private Unaided (Recognized) ",
          "Madarsa Unrecognized",
          "Madrasa Aided (Recognized)",
          "Other Central Govt./PSU Schools",
          "Minority Affairs Department",
          "Ministry of Labour",
          "Sainik School",
          "Jawahar Navodaya Vidyalaya",
        //  "Government Aided",
        // "Navodaya Vidyalaya Samiti ",
         'Veda Schools/Gurukuls/Pathashalas(Aided/Unaided)'
        ];
    
              
                
        console.log("arrGroupedData before update", arrGroupedData);
        let updatedGraphObject;
        let updatedGraphObjectCategories;
        let grouped;
        let graphUpdatedGraphObject = [
          { name: "Male", data: [] },
          { name: "Female", data: [] },
          { name: "Total", data: [] },
        ];
        
        // Enable group keys
        if (
          groupKeys.schManagementBroad ||
          groupKeys.schManagementDesc
        ) {
          grouped = arrGroupedData;
          updatedGraphObject = [...graphManagement];
          // graphUpdatedGraphObject = [...broadManagement]
        } else {
          groupKeysForGraph.schManagementBroad = true;
          console.log("data---",data)
          grouped = groupData(data, groupKeysForGraph);
          console.log('grouped', grouped)
          updatedGraphObject = [...graphManagement];
          // graphUpdatedGraphObject = [...broadManagement]
        }
    
        // Group the data and store it in a variable instead of state
    if(type=="broad"){
      broadManagement.forEach((item, index) => {
        grouped.forEach((items) => {
          if (items.schManagementBroad === item) {
            updatedGraphObject[0].data[index] = (updatedGraphObject[0]?.data[index] || 0) + (items.totTchCWSNTrainedM || 0);
            updatedGraphObject[1].data[index] =  (updatedGraphObject[1]?.data[index] || 0) +(items.totTchCWSNTrainedF || 0);              
            updatedGraphObject[2].data[index] =(updatedGraphObject[2]?.data[index] || 0) + (items.totTchCWSNTrained || 0);
          
          }
        });
      });

      setGraphData({
        categories: broadManagement,
        series: updatedGraphObject,
      });
      setGraphDataCategories({
        categories: broadManagement,
        series: updatedGraphObject,
      });
    }
    
    if(type=="desc"){
        managementDetailed.forEach((item, index) => {
          grouped.forEach((items) => {
            console.log(items.schManagementDesc+"-------------"+item);
            if (items.schManagementDesc === item) {
              updatedGraphObject[0].data[index] = (updatedGraphObject[0]?.data[index] || 0) + (items.totTchCWSNTrainedM || 0);
              updatedGraphObject[1].data[index] =  (updatedGraphObject[1]?.data[index] || 0) +(items.totTchCWSNTrainedF || 0);              
              updatedGraphObject[2].data[index] =(updatedGraphObject[2]?.data[index] || 0) + (items.totTchCWSNTrained || 0);
            }
          });
        });


        setGraphData({
          categories: managementDetailed,
          series: updatedGraphObject,
        });

       
       
   
        if(updatedGraphObject?.length > 0){
          //(A- State Government, B – Govt. Aided, C- Private Unaided, D- Central Government, E- Others)
          graphUpdatedGraphObject[0]['data']=updatedGraphObject[0]['data'];
          graphUpdatedGraphObject[1]['data']=updatedGraphObject[1]['data'];
          graphUpdatedGraphObject[2].data[0]=(updatedGraphObject[2]?.data[0]?updatedGraphObject[2]?.data[0]:0) + (updatedGraphObject[2]?.data[1]?updatedGraphObject[2]?.data[1]:0) + (updatedGraphObject[2]?.data[2]?updatedGraphObject[2]?.data[2]:0) + (updatedGraphObject[2]?.data[3]?updatedGraphObject[2]?.data[3]:0) + (updatedGraphObject[2]?.data[15]?updatedGraphObject[2]?.data[15]:0) + (updatedGraphObject[2]?.data[7]?updatedGraphObject[2]?.data[7]:0) + (updatedGraphObject[2]?.data[16]?updatedGraphObject[2]?.data[16]:0);
          graphUpdatedGraphObject[2].data[1]=(updatedGraphObject[2]?.data[5]) 
          graphUpdatedGraphObject[2].data[2]=(updatedGraphObject[2]?.data[4])
          graphUpdatedGraphObject[2].data[3]=((updatedGraphObject[2]?.data[8] + updatedGraphObject[2]?.data[17] + updatedGraphObject[2]?.data[9] + updatedGraphObject[2]?.data[10] + updatedGraphObject[2]?.data[14]))
          graphUpdatedGraphObject[2].data[4]=((updatedGraphObject[2]?.data[11] + updatedGraphObject[2]?.data[13] ))
      }
        


        console.log('graphUpdatedGraphObject', graphUpdatedGraphObject)
        setGraphDataCategories({
          categories: broadManagement,
          series: graphUpdatedGraphObject,
        });
      }
      console.log("updatedGraphObject---------", updatedGraphObject);
        // Update state with final graph data
      console.log("setGraphDataCategories",graphDataCategories)
    
        // setGraphDataCategories({
        //   categories: managementDetailed,
        //   series: updatedGraphObjectCategories,
        // });
    
 
        console.log("updatedGraphObjectCategories", updatedGraphObjectCategories);
        console.log("graphData", graphData);
      };
    
      // Mock translation function
      const trans = (key) => {
        const translations = {
          total_teachers_by_management_category:
            "Total Teachers by Management Category",
          total_teacher_by_management_category:
            "Total Teacher by Management Category",
          category: "Category",
        };
        return translations[key] || key;
      };



  return (
    <>
      <ScrollToTopOnMount onScrollComplete={handleScrollComplete} />
      {schData.isLoading && <GlobalLoading />}
      <section className="infrastructure-main-card p-0" id="content">
        <div className="bg-grey2 pb-0 pt-0 header-bar tab-for-graph">
          <div className="blue-strip">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-10 col-lg-10">
                  <div className="common-content text-start map-heading-map">
                    {report && (
                      <div className="common-content text-start map-heading-map d-flex align-items-center">
                        <span className="me-3">
                          {t("reports_id")}
                          {report.id}
                        </span>
                        <h2 className="heading-sm1 mb-0 mt-0">
                          {report.report_name}
                        </h2>
                      </div>
                    )}
                  </div>
                </div>

                {activeTab !== "about" && activeTab !== "graph" && (
                  <div className="col-md-2 col-lg-2">
                    <div className="select-infra button-group-filter">
                      <div className="indicator-select">
                        <select
                          id="export_data"
                          className="form-select bg-grey2"
                          onChange={handleExportData}
                          defaultValue={""}
                        >
                          <option className="option-hide">
                            {" "}
                            {t("download_report")}
                          </option>
                          <option value="export_pdf">
                            {t("download_as_pdf")}{" "}
                          </option>
                          <option value="export_excel">
                            {" "}
                            {t("download_as_excel")}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="container pb-4">
            <div className="row">
              {activeTab !== "about" && activeTab !== "graph" && (
                <div className="col-md-12 col-lg-12 d-flex align-items-center">
                  <div className="tab-text-infra me-4">
                    {" "}
                    {t("view_data_by")}
                  </div>
                  <ul className="nav nav-tabs mul-tab-main">
                    <li className={`nav-item ${multiMgt}`}>
                      <button
                        type="button"
                        className={`nav-link dark-active ${mgt}`}
                        onClick={(e) =>
                          handleButtonClick("School Management", "broad", e)
                        }
                      >
                        {t("school_management_board")}
                      </button>
                      <button
                        type="button"
                        className={`nav-link dark-active details-multi ${mgt_Details}`}
                        id="school_mgt_details"
                        onClick={(e) =>
                          handleButtonClick("School Management", "desc", e)
                        }
                      >
                        {t("detailed_view")}
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="bg-grey ptb-30">
          <div className="container tab-for-graph">
            <div className="row align-items-center report-inner-tab">
              <div className="col-md-12 col-lg-12 table-text-i table-brud-card">
                {activeTab !== "about" && (
                  <h4 className="brudcrumb_heading">
                    {t("showing_result_for")} <span>&nbsp;{local_state}</span>
                    <span className="material-icons-round">chevron_right</span>
                    {local_district !== "District" && (
                      <>
                        <span>{local_district}</span>
                        <span className="material-icons-round">
                          chevron_right
                        </span>
                      </>
                    )}
                    {local_block !== "Block" && (
                      <>
                        <span>{local_block}</span>
                        <span className="material-icons-round">
                          chevron_right
                        </span>
                      </>
                    )}
                    <span>{local_year}</span>
                  </h4>
                )}
                <Tabs
                  defaultActiveKey={type}
                  id="uncontrolled-tab-example"
                  className="nav-absolute"
                  onSelect={(k) => setActiveTab(k)}
                >
                  {/* <Tab eventKey="about" title={t("about")}>
                    <div className="about-card mt-4">
                      <h2 className="heading-sm2 mb-2">{t("about_us")}</h2>
                      <p>
                        The "Number of Teachers Trained for Teaching CWSN by
                        School Management" refers to the count and
                        categorization of teachers who have received specialized
                        training to educate Children with Special Needs (CWSN).
                        This data is further broken down by school management,
                        which includes different types of schools such as
                        government schools, private schools, and
                        government-aided schools. Training for teaching CWSN is
                        crucial as it equips teachers with the skills and
                        knowledge required to address the unique educational
                        needs of students with disabilities or learning
                        challenges. Such training includes understanding
                        different disabilities, adapting teaching methods, using
                        specialized learning tools, and creating an inclusive
                        classroom environment where all students, regardless of
                        their abilities, can thrive. By categorizing this data
                        according to school management, the analysis helps to
                        identify which types of schools are more or less
                        equipped to handle the educational needs of CWSN
                        students. For instance, it may reveal whether government
                        schools or private institutions have more trained
                        teachers in this area, or if certain management systems
                        are better at integrating inclusive education practices.
                        This data is essential for policymakers, as it
                        highlights gaps in the training of educators, ensuring
                        that schools are adequately staffed with teachers who
                        are prepared to provide quality education to CWSN
                        students. It also serves to inform future training
                        initiatives, resource allocation, and the development of
                        inclusive education policies aimed at providing equal
                        learning opportunities for all children.
                      </p>
                    </div>
                  </Tab> */}
                  <Tab eventKey="table" title={t("table")}>
                    <div className="multi-header-table">
                      <div
                        className=" multi-header-table ag-theme-quartz ag-theme-custom-height h-300"
                        style={{ height: 450 }}
                      >
                        <AgGridReact
                          key={gridRefreshKey}
                          rowData={
                            isCheckFilter
                              ? arrGroupedData
                              : filter_query_by_location &&
                                (groupKeys.schManagementBroad ||
                                  groupKeys.schManagementDesc ||
                                  groupKeys.schLocURDesc ||
                                  groupKeys.category)
                              ? result
                              : arrGroupedDataTable
                              ? arrGroupedDataTable
                              : []
                          }
                          getRowStyle={(params) => {
                            if (params.data.isTotalRow) {
                              return { fontWeight: "bold" }; // Apply inline bold style for totals row
                            }
                            return {}; // Default style for other rows
                          }}
                          columnDefs={columns}
                          defaultColDef={defColumnDefs}
                          onColumnVisible={onColumnVisible}
                          onGridReady={onGridReady}
                          groupDisplayType="custom"
                          groupHideOpenParents={true}
                          onFilterChanged={onFilterChanged}
                          pinnedBottomRowData={customChange}
                          excelStyles={excelStyles}
                        />
                      </div>
                    </div>
                  </Tab>
                  <Tab disabled eventKey="graph" title={t("chart")} >
                    <div className="card-box-impact tab-for-graph report-2008 mt-4 tab-content-reduce">
                      <div className="row">
                        <div className="col-md-12 col-lg-12 d-flex align-items-center">
                          <div className="tab-text-infra me-4">
                            {" "}
                            {t("view_data_by")}
                          </div>
                          <ul className="nav nav-tabs mul-tab-main">
                            <li className={`nav-item ${multiMgt}`}>
                              <button
                                type="button"
                                className={`nav-link dark-active ${mgt}`}
                                onClick={(e) =>
                                  handleButtonClick(
                                    "School Management",
                                    "broad",
                                    e
                                  )
                                }
                              >
                                {t("school_management_board")}
                              </button>
                              <button
                                type="button"
                                className={`nav-link dark-active details-multi ${mgt_Details}`}
                                id="school_mgt_details"
                                onClick={(e) =>
                                  handleButtonClick(
                                    "School Management",
                                    "desc",
                                    e
                                  )
                                }
                              >
                                {t("detailed_view")}
                              </button>
                            </li>
                          </ul>
                        </div>

                        <div className="col-md-12 col-lg-12">
                          <div className="impact-box-content-education mt-3">
                            <div className="text-btn-d">
                              <h2 className="heading-sm">
                                Number of Teachers Trained for Teaching CWSN by
                                School Management ( {selectedBtn} )
                              </h2>
                            </div>

                            <div className="piechart-box mt-4">
                              <TeacherGraph2011
                                graphScmSchDataBrod={graphData}
                                t={trans}
                                title={`Number of Teachers Trained for Teaching CWSN by
                                School Management ( ${selectedBtn} )`}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 col-lg-6">
                          <div className="impact-box-content-education mt-3">
                            <div className="text-btn-d">
                              <h2 className="heading-sm">
                                Percentage of Teachers Trained for Teaching CWSN
                                by School Management ( {selectedBtn} )
                              </h2>
                            </div>

                            <div className="piechart-box mt-4">
                              <TeacherPieGraphManagement2011
                                teacherDataValueTypeBroad={graphDataCategories}
                                t={trans}
                                title={`Percentage of Teachers Trained for Teaching CWSN
                                by School Management ${selectedBtn}`}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <div className="impact-box-content-education mt-3">
                            <div className="text-btn-d">
                              <h2 className="heading-sm">
                                Percentage of Teachers Trained for Teaching CWSN
                                by Male and Female
                              </h2>
                            </div>

                            <div className="piechart-box mt-4">
                              <TeacherPieGraphManagementBroad2011
                                teacherDataValueTypeBroad={graphDataCategories}
                                t={trans}
                                title="Percentage of Teachers Trained for Teaching CWSN
                                by Male and Female"                        
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <FilterDropdownCommom358 />
    </>
  );
}
